import { render, staticRenderFns } from "./Voyager.vue?vue&type=template&id=d5d4f4fa&scoped=true&"
import script from "./Voyager.vue?vue&type=script&lang=js&"
export * from "./Voyager.vue?vue&type=script&lang=js&"
import style0 from "./Voyager.vue?vue&type=style&index=0&id=d5d4f4fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d4f4fa",
  null
  
)

export default component.exports